<template>
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
    <div class="flex w-full items-center gap-2">
      <div class="relative flex-1">
        <MagnifyingGlassIcon
          class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
        />
        <input
          :value="modelValue"
          type="text"
          :placeholder="placeholder"
          class="form-input pl-10"
          @input="onInput"
          @keyup.enter="emitSearch"
        />
      </div>
      <button
        v-if="showButton"
        class="btn btn-outline btn-sm px-3 sm:hidden"
        :disabled="disabled"
        @click="emitSearch"
      >
        <MagnifyingGlassIcon class="w-5 h-5" />
      </button>
    </div>
    <div v-if="showButton" class="hidden sm:flex flex-wrap gap-2">
      <Button
        type="outline"
        size="md"
        icon="search"
        :text="buttonText"
        text-size="md"
        :disabled="disabled"
        @click="emitSearch"
      />
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline'
import Button from '@/components/common/Button/Button.vue'

interface Props {
  modelValue: string
  placeholder?: string
  buttonText?: string
  showButton?: boolean
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  placeholder: '검색어를 입력하세요.',
  buttonText: '검색',
  showButton: false,
  disabled: false
})

const emit = defineEmits<{
  'update:modelValue': [value: string]
  search: []
}>()

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)
}

const emitSearch = () => {
  emit('search')
}
</script>
